<template>
  <div>
    <p v-if="timeout" class="subtitle">
      Podrás solicitar otro código en
      {{ timeEnd }}
    </p>
    <div
      v-else
      style="display: flex; gap: 4px; align-items: center"
      class="flex gap-2"
    >
      <p class="subtitle m-0">¿No recibiste el código?</p>
      <button
        :disabled="resending"
        @click="onResend()"
        type="button"
        style="
          color: #00B38E;
          font-weight: 700;
          background: none;
          border: none;
          padding: 0;
          font-size: 14px;
        "
      >
        <template v-if="!resending">
          Reenviar código
        </template>
        <!-- <i v-show="resending" class="fa fa-spinner fa-pulse fa-sm fa-fw" /> -->
      </button>
    </div>
  </div>
</template>

<script>
const { VUE_APP_TWO_STEP_RESEND_TIME } = process.env;
let intervalId = null;
export default {
  props: {
    time: {
      type: String,
      default: VUE_APP_TWO_STEP_RESEND_TIME,
    },
    resend: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      timeout: this.time,
      resending: false,
    };
  },
  computed: {
    timeEnd() {
      const { timeout } = this;
      const oneMinInMlsc = 60;
      const minutes = Math.trunc(timeout / oneMinInMlsc);
      const seconds = timeout - minutes * oneMinInMlsc;
      return `${minutes}:${String(seconds).padStart(2, 0)} ${minutes ? 'min' : 'seg'}`;
    },
  },
  mounted() {
    intervalId = setInterval(() => {
      if (this.timeout > 0) {
        this.timeout = this.timeout - 1;
      }
    }, 1000);
  },
  beforeDestroy() {
    if (intervalId) clearInterval(intervalId);
  },
  methods: {
    resetTime() {
      const { time } = this;
      this.timeout = time;
    },
    async onResend() {
      const { resend } = this;
      this.resending = true;
      await resend();
      this.resending = false;
      this.resetTime();
    }
  },
}
</script>

<style>

</style>